import {AfterViewInit, Component, Input, NgZone, OnChanges, OnDestroy, OnInit} from '@angular/core';

import { RequestService } from 'src/app/services/request/request.service';
import Swal2 from 'sweetalert2';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import {SliderInformationComponent} from "../slider-information/slider-information.component";
import { PagoTarjetaComponent } from './Pago-Tarjeta/Pago-Tarjeta.component';
import {ReconoceridComponent} from "../slider-information/reconocerid/reconocerid.component";
import { Browser } from '@capacitor/browser';
import { App } from '@capacitor/app';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { ActivatedRoute } from '@angular/router';
import {Confirmacion} from 'src/app/components/email-confirm/ConfirmaciondeCorreo1/Confirmacion';
import { InAppPurchase2,IAPProduct } from '@awesome-cordova-plugins/in-app-purchase-2/ngx';
import { Platform } from '@ionic/angular';
//import { LocalNotifications } from '@capacitor/local-notifications';
import  Swal from 'sweetalert2';
import { Plugins } from '@capacitor/core';
import { Capacitor } from '@capacitor/core';
import { SecureOperationFeedbackService } from 'src/app/services/ui/secure-operation-feedback.service';
import { SubscriptionReconciliationService } from 'src/app/services/profile/subscription-reconciliation.service';

const { LocalNotifications } = Plugins;

type VerificationPurchaseFlow = 'initial-bundle' | 'inscription' | 'subscription';
type SubscriptionActivationMode = 'initial' | 'finalize';

@Component({
  selector: 'app-pago-verificacion',
  templateUrl: './pago-verificacion.component.html',
  styleUrls: ['./pago-verificacion.component.scss']
})
export class PagoVerificacionComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  public typeTextCalled:boolean=false;
  public textAlign:any;
  @Input() pr: any = {};
  @Input() pageMode = false;
  @Input() returnUrl = '/home/ecosystem-page';
  purchaseInProgress = false;
  activePurchaseFlow: VerificationPurchaseFlow | null = null;
  private destroyed = false;
  private subscriptionSyncRunning = false;
  private subscriptionSyncTimer?: ReturnType<typeof setTimeout>;
  private subscriptionRetryCount = 0;
  subscriptionActivationPending = false;
  private readonly applePurchaseFallbackMs = 6000;
  private purchaseAttemptId = 0;
  private purchaseFallbackTimer?: ReturnType<typeof setTimeout>;
  private purchaseFallbackOccurred = false;
  // StoreKit may replay approved/owned events and this component historically
  // registered a listener for every attempt. These sets make each successful
  // Apple transaction side effect happen exactly once per UI attempt.
  private readonly handledIapApprovalAttempts = new Set<string>();
  private readonly handledIapSuccessAttempts = new Set<string>();
  private sumaStatusSyncInFlight = false;
  private sumaCaptureOpening = false;
  private sumaCaptureGeneration = 0;
  private sumaStatusSyncPromise?: Promise<boolean>;
  private sumaStatusPollingTimer?: ReturnType<typeof setTimeout>;
  private sumaStatusPollingStartedAt?: number;
  private sumaAppStateListener?: { remove: () => Promise<void> };
  private sumaVerificationModal?: HTMLIonModalElement;
  private sumaRetryNoticeShown = false;
  sumaReturnLoading = false;
  private sumaReturnTimer?: ReturnType<typeof setTimeout>;
  private sumaPollingGeneration = 0;
  private readonly sumaStatusPollingIntervalMs = 10000;
  private readonly sumaStatusPollingMaxMs = 3 * 60 * 1000;
  private emailStatusSyncPromise?: Promise<boolean>;
  private emailStatusPollingTimer?: ReturnType<typeof setTimeout>;
  private emailStatusPollingStartedAt?: number;
  private emailVerificationModal?: HTMLIonModalElement;
  private readonly emailStatusPollingIntervalMs = 5000;
  private readonly emailStatusPollingMaxMs = 2 * 60 * 1000;

  // Beautiful qubit/atom loader (replaces basic loading)
  showQubitLoader = false;
  qubitTitle = 'Iniciando verificación';
  qubitSubtitle = 'Sincronizando datos biométricos y abriendo canal seguro.';
  profileinfo: any;
  urldirection: any;
  readonly termsOfUseUrl = 'https://sitio.laniakea.tv/post/terminos-y-condiciones-del-servicio';
  readonly privacyPolicyUrl = 'https://sitio.laniakea.tv/post/politica-de-privacidad';
  productId: string = '123';
  productId2: string = '1618';
  web:boolean=false;
  constructor(
    private router: Router,
    private request: RequestService,
    private sliderInfo: SliderInformationComponent,
    private modalcontroller: ModalController,
    private profile_service: ProfileService,
    public route: ActivatedRoute,
    private Confirmacion: Confirmacion,
    private store: InAppPurchase2, 
     private platform: Platform,
     private secureFeedback: SecureOperationFeedbackService,
     private ngZone: NgZone,
     private subscriptionReconciliation: SubscriptionReconciliationService,
    // private localNotification: LocalNotifications,
 
    ) {
    // Loader will be shown after main loading completes for a guaranteed 3s gap
     }

  ngOnInit() {
    this.registerSumaResumeSync();
    this.pageMode = this.pageMode || this.route.snapshot.routeConfig?.path === 'pago-verificacion';
    if (this.pageMode) {
      this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || this.returnUrl;
      const navigationProfile = (history.state as { profile?: any })?.profile;
      if (navigationProfile && typeof navigationProfile === 'object') {
        this.pr = navigationProfile;
      }
    }

    if (this.pageMode && !this.pr?.id) {
      void this.loadPageProfile();
      return;
    }

    this.initializePaymentView();
  }

  ngOnChanges(): void {
    // Some callers provide the profile after constructing the modal. Always
    // run the status preflight once that profile arrives.
    if (this.isSumaReconciliationEligible()) {
      void this.syncSumaVerificationStatus();
    } else if (this.pr?.kyc === 'MailVerification') {
      void this.syncEmailVerificationStatus();
    }
  }

  private async loadPageProfile(): Promise<void> {
    try {
      const rawProfileId = this.route.snapshot.queryParamMap.get('profile_id');
      const profileId = rawProfileId ? Number(rawProfileId) : undefined;
      const response = await this.profile_service.getProfileInfo(profileId);
      const profile = this.parseProfile(response);
      if (profile) {
        this.pr = profile;
        this.initializePaymentView();
      }
    } catch (error) {
      console.error('Unable to load the payment profile.', error);
    }
  }

  private parseProfile(response: any): any | null {
    let data = response;
    while (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch {
        return null;
      }
    }

    const candidates = [data?.profile, data?.data?.profile, data?.data, data?.success, data];
    return candidates.find((candidate) => candidate && typeof candidate === 'object' && !Array.isArray(candidate)) || null;
  }

  private initializePaymentView(): void {
    try { this.subscriptionActivationPending = localStorage.getItem(`pending-apple-subscription:${this.pr.id}`) === '1'; } catch { /* Optional recovery hint. */ }
    void this.reconcileCurrentSubscription();
    // On each entry, reconcile a completed Suma flow with the server.  The
    // backend is the source of truth; changing `this.pr.kyc` locally alone
    // caused the completed user to see the Suma step again after reopening.
    if (this.isSumaReconciliationEligible()) {
      void this.syncSumaVerificationStatus();
    } else if (this.pr?.kyc === 'MailVerification') {
      void this.syncEmailVerificationStatus();
    }
    console.log('profile antes de pagar', this.pr);

    // The beautiful qubit loader will be shown after getprofile() completes (see getprofile)
    this.getprofile();
    
    if (Capacitor.getPlatform() === 'web') {
this.web=true;
    }

  }

  async dismiss(){
    if (this.pageMode) {
      await this.router.navigateByUrl(this.returnUrl);
      return;
    }

    await this.modalcontroller.dismiss();
  }
  open_android_iab(loginUrl){
    const browser = window.open(loginUrl, '_blank', 'location=yes,toolbar=yes');

    const interval = setInterval(() => {
      if (browser?.closed) {
      clearInterval(interval);
      console.log('Window was closed.');
      }
    }, 500);
    }

  async openBrowser(url: string) {
    if (Capacitor.getPlatform() !== 'android') {
      await Browser.open({ url:url });
    }else{
      this.open_android_iab(url);
      }
}

  async openLegalDocument(url: string) {
    await Browser.open({ url });
  }

async getOnboardingLinkAndCheckStatus() {
  // Send a POST request to your server API
  // Get the onboarding link URL
  this.request.createRequestPost('Onboard', { id: this.pr.id, email: this.profileinfo.user.email })
      .then(response => {
          if (response) {

              console.log('After API call:', response);  // Log the received response
              this.handleResponse(response);  // Handle the response
              this.sendNotification('Estatus de tu perfil actualizado', '¡Felicitaciones! Continua con el siguiente paso para verificarte.');
          } else {
              console.error('No response from API call.');
          }
      })
      .catch(error => {
          console.error('Error from API call:', error);  // Log error from API call
      });
}

// This function can be used to handle the response from both API calls
handleResponse(response: any) {
  try {
    if(Capacitor.getPlatform() !=='web'){
      this.urldirection = JSON.parse(response);  // Try to parse the response
    }else{
      this.urldirection = response;  // Try to parse the response
    }

      console.log('Parsed response:', this.urldirection);  // Log the parsed response
      if (this.urldirection && this.urldirection.url) {  // Check if the parsed response has a 'url' property
          // Open the browser with the received URL
          this.openBrowser(this.urldirection.url);
      } else if (this.urldirection && this.urldirection.status === 'complete') {
        this.sendNotification('Estatus de tu perfil actualizado', '¡Felicitaciones! Continua con el siguiente paso para verificarte.');
        Swal2.fire({
          title: 'Formulario financiero exitoso',
  
          icon: 'success',
          confirmButtonText: 'OK',
          color: '#ffffff',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
        });
      } else {
          console.error('Parsed response does not contain a URL.');
      }
  } catch (error) {
      console.error('Failed to parse response:', error);  // Log the error if parsing failed
  }
}


  
  async metodoTarjeta(inscription_or_subscription?){
    let openpay_subscription_payment;
    if(inscription_or_subscription === 'inscription'){
      openpay_subscription_payment=false;
      // Browser inscription payments deliberately use the method picker in a
      // real modal. The historic popover is tiny and navigates behind itself,
      // while native clients keep their established card flow.
      const useWebMethodPicker = Capacitor.getPlatform() === 'web';
      this.modalcontroller.create({
        component: PagoTarjetaComponent,
        cssClass: useWebMethodPicker ? 'inscription-payment-method-modal' : 'detailsInModal',
        canDismiss: true,
        componentProps: {
          openpay_subscription_payment:openpay_subscription_payment,
          profile: this.pr,
          // The picker is browser-only. Selecting Stripe preserves the same
          // PagoTarjetaComponent card submission and `stripe-pay` request.
          pago_tarjeta_stripe: !useWebMethodPicker,
        }
        }).then((modal) => {
        modal.onDidDismiss().then((data) => {
      
        
        });
        modal.present();
         // Listen to the output when the modal is dismissed
      
        }).catch((error) => {
        console.error(error);
        });
    }else if(inscription_or_subscription==='subscription'){
      openpay_subscription_payment=true;
      this.open_tarjeta(openpay_subscription_payment);
    }
   
  }

  async open_tarjeta(openpay_subscription_payment){
    const modal = await this.modalcontroller.create({
      component: PagoTarjetaComponent,
      cssClass: 'detailsInModal',
      canDismiss: true, // (forced globally for swipe close on all modals)
      componentProps: {
        openpay_subscription_payment:openpay_subscription_payment,
        profile: this.pr,
        pago_tarjeta_stripe:true
      },
    });
    modal.onDidDismiss().then((data) => {

      console.log('profile after pay', this.pr);
    });
    return await modal.present();
  }

  async reconoserid(){
    if (this.destroyed || this.sumaCaptureOpening || this.sumaVerificationModal) return;
    this.sumaCaptureOpening = true;
    ++this.sumaCaptureGeneration;
    this.stopSumaStatusPolling();
    this.finishSumaReturnLoading();
    this.sumaRetryNoticeShown = false;
    try {
      const modal = await this.modalcontroller.create({
        cssClass: 'identity-verification-fullscreen-modal',
        canDismiss: true, // (forced globally for swipe close on all modals)
        component: ReconoceridComponent,
        componentProps: {
          profile: this.pr,
          correo: this.profileinfo?.user?.email || '',
          onVerificationStarted: () => {
            this.ngZone.run(() => {
              this.sumaRetryNoticeShown = false;
              this.stopSumaStatusPolling();
            });
          },
        },
      });
      this.sumaVerificationModal = modal;
      modal.onWillDismiss().then((detail) => {
        if (detail.role === 'verification-complete' && !this.destroyed) {
          this.ngZone.run(() => {
            this.sumaReturnLoading = true;
            this.sumaReturnTimer = setTimeout(() => {
              this.finishSumaReturnLoading();
              void Swal2.fire({
                title: 'Seguimos revisando tu verificación',
                text: 'El resultado aún no está disponible. Actualizaremos este paso automáticamente cuando esté listo.',
                icon: 'info',
                confirmButtonText: 'Entendido',
              });
            }, 30000);
          });
        }
      });
      modal.onDidDismiss().then(async (detail) => {
        if (this.sumaVerificationModal !== modal) return;
        this.sumaVerificationModal = undefined;
        this.stopSumaStatusPolling();
        if (this.destroyed || detail.role !== 'verification-complete') {
          this.finishSumaReturnLoading();
          return;
        }

        // Suma can finish while its iframe is open. Reconcile once more when it
        // closes; do not send an application notification for this background
        // state update.
        const completed = await this.syncSumaVerificationStatus();

        // VeriDoc can reach its completion redirect a few seconds before its
        // results API exposes the final decision. Keep reconciling in the
        // background after the iframe closes so the next persisted step appears
        // without asking the user to reopen or manually dismiss anything.
        if (detail.role === 'verification-complete' && !completed && !this.sumaRetryNoticeShown && !this.destroyed) {
          this.startSumaStatusPolling();
        } else {
          this.finishSumaReturnLoading();
        }
      });
      await modal.present();
    } catch (error) {
      this.sumaVerificationModal = undefined;
      console.error('Unable to present identity verification.', error);
    } finally {
      this.sumaCaptureOpening = false;
    }
  }

  ngAfterViewInit(): void {
    console.log('after init pago verificacion');
    //this.sendNotification('¿Inconveniente con la verificación?', 'Toca aquí para saber más de la verificación');
    this.web=true;
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    clearTimeout(this.subscriptionSyncTimer);
    this.finishSumaReturnLoading();
    this.stopSumaStatusPolling();
    this.stopEmailStatusPolling();
    void this.sumaAppStateListener?.remove();
    this.clearPurchaseFallbackTimer();
    this.showQubitLoader = false;
    if (this.purchaseInProgress) this.subscriptionReconciliation.purchaseInProgress = false;
    this.purchaseInProgress = false;
    this.activePurchaseFlow = null;
    this.secureFeedback.hide();
  }
  getprofile() {
    this.request.createRequestGet("profile-all", null, { id: this.pr.id })
        .then((data => {
            this.profileinfo = JSON.parse(data);
            console.log("Successfully fetched profile info.");
            console.log("Profile info:", this.profileinfo);
            console.log("Email:", this.profileinfo.user.email);

            // After everything is loaded, show the beautiful qubit/atom animation
            // for a guaranteed 3 seconds as a visible "gap"
            if (!this.purchaseInProgress && !this.purchaseFallbackOccurred) {
              this.showBeautifulQubitLoaderFor(3000, 'Neural link calibrating', 'Sincronizando datos para verificación.');
            }
        }))
        .catch((error) => {
            console.error("Error fetching profile info:", error);
        });
}

  private showBeautifulQubitLoaderFor(durationMs: number = 3000, title = 'Neural link calibrating', subtitle = '') {
    this.qubitTitle = title;
    this.qubitSubtitle = subtitle || 'Procesando...';
    this.showQubitLoader = true;

    setTimeout(() => {
      if (!this.purchaseInProgress) {
        this.showQubitLoader = false;
      }
    }, durationMs);
  }

  purchaseButtonLabel(flow: VerificationPurchaseFlow): string {
    if (this.purchaseInProgress && this.activePurchaseFlow === flow) {
      return 'Procesando con Apple…';
    }

    if (flow === 'initial-bundle') {
      return Capacitor.getPlatform() === 'ios'
        ? 'Pagar inscripción y activar suscripción'
        : 'Pagar ahora';
    }

    return flow === 'inscription' ? 'Pagar ahora' : '0.99 USD/mes';
  }

  /** New KYC-first onboarding is explicit so historic status-5 profiles keep
   * their original payment-first/KYC behavior. Do not infer the new meaning
   * from status 5 alone: it is intentionally overloaded for API compatibility.
   * The server-provided stage is the authority for this UI branch. */
  isCheckoutStep(): boolean {
    return this.pr?.kyc === 'Pagado' && this.pr?.verification_flow_stage === 'checkout';
  }

  isLegacyKycStep(): boolean {
    return this.pr?.kyc === 'Pagado' && !this.isCheckoutStep();
  }

  isKycStartStep(): boolean {
    const kyc = String(this.pr?.kyc || '').trim().toLowerCase();
    return kyc === 'sin validar'
      || kyc === 'en validacion'
      || kyc === 'en validación'
      || kyc === 'rechazado';
  }

  hasInscriptionPayment(): boolean {
    return Boolean(String(this.pr?.inscription_payment_source || '').trim());
  }

  checkoutPurchaseFlow(): VerificationPurchaseFlow {
    if (this.hasInscriptionPayment()) {
      return 'subscription';
    }

    return Capacitor.getPlatform() === 'ios' ? 'initial-bundle' : 'inscription';
  }

  checkoutButtonLabel(): string {
    const flow = this.checkoutPurchaseFlow();
    if (this.purchaseInProgress) {
      return this.purchaseButtonLabel(flow);
    }

    if (flow === 'initial-bundle') {
      return 'Activar inscripción y Premium';
    }

    return flow === 'inscription' ? 'Pagar inscripción' : 'Activar Premium';
  }

  isSubscriptionManagementStep(): boolean {
    // Status 3 is a verified profile with an inactive/expired entitlement;
    // status 10 is verified with an active one. Keep both on the billing
    // screen so a failed renewal never strands an already verified user.
    return this.pr?.kyc === 'Verified' || this.pr?.kyc === 'Validado';
  }

  private beginPurchaseFeedback(flow: VerificationPurchaseFlow): number {
    this.subscriptionRetryCount = 0;
    this.subscriptionReconciliation.purchaseInProgress = true;
    const attemptId = ++this.purchaseAttemptId;
    this.purchaseInProgress = true;
    this.activePurchaseFlow = flow;
    this.updatePurchaseStatus(
      flow === 'initial-bundle'
        ? 'Preparando tus compras'
        : flow === 'inscription'
          ? 'Preparando inscripción'
          : 'Preparando suscripción',
      'Conectando de forma segura con App Store.'
    );
    this.clearPurchaseFallbackTimer();
    this.purchaseFallbackTimer = setTimeout(() => {
      if (
        this.destroyed
        || attemptId !== this.purchaseAttemptId
        || !this.purchaseInProgress
        || this.activePurchaseFlow !== flow
      ) {
        return;
      }

      // StoreKit can take longer than expected to present its native sheet.
      // Hide only the visual loader: the purchase lock must remain active so a
      // second tap cannot start a duplicate transaction while StoreKit is open.
      this.showQubitLoader = false;
      this.purchaseFallbackOccurred = true;
      this.secureFeedback.hide();
      this.clearPurchaseFallbackTimer();
    }, this.applePurchaseFallbackMs);
    return attemptId;
  }

  private clearPurchaseFallbackTimer(): void {
    if (this.purchaseFallbackTimer) {
      clearTimeout(this.purchaseFallbackTimer);
      this.purchaseFallbackTimer = undefined;
    }
  }

  private isCurrentPurchaseAttempt(attemptId: number): boolean {
    return !this.destroyed && attemptId === this.purchaseAttemptId;
  }

  private claimIapApproval(flow: 'inscription' | 'subscription', attemptId: number): boolean {
    if (!this.isCurrentPurchaseAttempt(attemptId)) {
      return false;
    }

    const key = `${flow}:${attemptId}`;
    if (this.handledIapApprovalAttempts.has(key)) {
      return false;
    }

    this.handledIapApprovalAttempts.add(key);
    return true;
  }

  private claimIapSuccess(flow: 'inscription' | 'subscription', attemptId: number): boolean {
    if (!this.isCurrentPurchaseAttempt(attemptId)) {
      return false;
    }

    const key = `${flow}:${attemptId}`;
    if (this.handledIapSuccessAttempts.has(key)) {
      return false;
    }

    this.handledIapSuccessAttempts.add(key);
    return true;
  }

  private iapNotificationKey(flow: 'inscription' | 'subscription', attemptId: number, product: any): string {
    // Prefer Apple's transaction identifier when the plugin exposes it. The
    // attempt id keeps all replayed callbacks from this app session identical
    // on older plugin versions that do not expose a transaction identifier.
    const transactionId = product?.transaction?.transactionId
      || product?.transaction?.id
      || product?.transactionId
      || product?.purchaseId
      || attemptId;

    return `iap:${flow}:profile:${this.pr?.id}:transaction:${transactionId}`;
  }

  private updatePurchaseStatus(title: string, subtitle: string, attemptId?: number): void {
    if (this.destroyed || (attemptId !== undefined && attemptId !== this.purchaseAttemptId)) {
      return;
    }

    this.qubitTitle = title;
    this.qubitSubtitle = subtitle;
    this.showQubitLoader = true;
  }

  private isPurchaseCancelled(error: unknown): boolean {
    return error instanceof Error && error.message === 'IAP_PURCHASE_CANCELLED';
  }

  private async refreshVerificationProfile(attemptId?: number, showLoader = true): Promise<void> {
    if (showLoader) {
      this.updatePurchaseStatus('Actualizando tu estado', 'Cargando el siguiente paso de verificación.', attemptId);
    }

    // `profile` is normally short-cached to make navigation faster. Status
    // reconciliation after a payment/KYC/email mutation must bypass that cache
    // or the UI can keep rendering the previous step for up to 45 seconds.
    const response = await this.request.createRequestGet(
      'profile',
      { verification_refresh: Date.now() },
      this.pr?.id ? { id: this.pr.id } : null,
    );
    const refreshedProfile = this.parseProfile(response);

    if (!refreshedProfile || typeof refreshedProfile !== 'object') {
      throw new Error('The refreshed verification profile is invalid');
    }

    // StoreKit callbacks can execute outside Angular's zone. Apply the fetched
    // persisted status inside the zone so the *ngIf verification steps redraw
    // immediately after a successful in-app purchase.
    this.ngZone.run(() => {
      // Mutate the original modal input first so callers holding this object
      // also receive the new status, then replace the local reference.
      Object.assign(this.pr, refreshedProfile);
      this.pr = { ...this.pr };
      this.profile_service.profile = { ...(this.profile_service.profile || {}), ...refreshedProfile };
      this.typeTextCalled = false;
      this.textAlign = '';
    });
  }

  private persistedVerificationStatusName(statusId: unknown, fallback: string): string {
    const statusNames: Record<number, string> = {
      1: 'Sin Validar',
      3: 'Validado',
      5: 'Pagado',
      9: 'MailVerification',
      10: 'Verified',
    };
    const numericStatusId = Number(statusId);

    return statusNames[numericStatusId] || fallback;
  }

  /**
   * A purchase endpoint is the authority for the transition it just committed.
   * If the follow-up profile read fails or reaches a stale edge cache, reflect
   * that committed response locally so StoreKit can finish the transaction and
   * a retry cannot create a second charge.
   */
  private applyPersistedPurchaseStatus(statusId: unknown, fallback: string): void {
    const numericStatusId = Number(statusId);
    const kyc = this.persistedVerificationStatusName(statusId, fallback);
    const statusPatch: Record<string, unknown> = { kyc };

    if (Number.isFinite(numericStatusId) && numericStatusId > 0) {
      statusPatch.profile_status_id = numericStatusId;
    }

    this.ngZone.run(() => {
      if (this.pr && typeof this.pr === 'object') {
        Object.assign(this.pr, statusPatch);
      }
      this.pr = { ...(this.pr || {}), ...statusPatch };
      this.profile_service.profile = {
        ...(this.profile_service.profile || {}),
        ...statusPatch,
      };
      this.typeTextCalled = false;
      this.textAlign = '';
    });
  }

  /**
   * Queries Suma through our authenticated backend endpoint and then refreshes
   * the persisted profile. This is intentionally idempotent: it only moves a
   * profile from an active KYC checkpoint to MailVerification after the backend accepts Suma's
   * provider result or the narrowly scoped visual-quality tolerance.
   */
  private syncSumaVerificationStatus(): Promise<boolean> {
    if (this.destroyed || this.sumaCaptureOpening || this.sumaVerificationModal || !this.isSumaReconciliationEligible()) {
      return Promise.resolve(false);
    }

    // An entry sync and a button tap can occur at nearly the same time. Both
    // callers must await the same result instead of the second one opening a
    // new Suma session while the first is still confirming completion.
    if (this.sumaStatusSyncPromise) {
      return this.sumaStatusSyncPromise;
    }

    const syncPromise = this.performSumaVerificationStatusSync();
    this.sumaStatusSyncPromise = syncPromise;
    syncPromise.then(
      () => {
        if (this.sumaStatusSyncPromise === syncPromise) {
          this.sumaStatusSyncPromise = undefined;
        }
      },
      () => {
        if (this.sumaStatusSyncPromise === syncPromise) {
          this.sumaStatusSyncPromise = undefined;
        }
      }
    );

    return syncPromise;
  }

  private async performSumaVerificationStatusSync(): Promise<boolean> {
    if (this.sumaStatusSyncInFlight) {
      return false;
    }

    this.sumaStatusSyncInFlight = true;
    const captureGeneration = this.sumaCaptureGeneration;

    try {
      const rawResponse = await this.request.createRequestPost('update_sumamexico_veridocid_auth', {});
      if (this.destroyed || this.sumaCaptureOpening || this.sumaVerificationModal || captureGeneration !== this.sumaCaptureGeneration) return false;
      const response: any = this.parseNestedSumaResponse(rawResponse);
      const providerResponse = this.parseNestedSumaResponse(response?.success);
      const providerGlobalResult = this.findSumaGlobalResult(providerResponse);
      const profileStatusId = Number(response?.profile_status_id);
      const responseKyc = response?.kyc
        || (profileStatusId === 9 ? 'MailVerification' : null)
        || (profileStatusId === 10 ? 'Verified' : null)
        || (profileStatusId === 3 ? 'Validado' : null);
      const verified = this.isTrueFlag(response?.verified)
        || providerGlobalResult === 'Ok'
        || ['MailVerification', 'Verified', 'Validado'].includes(responseKyc);

      const retryAllowed = !verified && (
        this.isTrueFlag(response?.retry_allowed)
        || response?.next_step === 'suma_verification_retry'
      );

      if (retryAllowed) {
        this.finishSumaReturnLoading();
        this.stopSumaStatusPolling();

        const activeModal = this.sumaVerificationModal;
        this.sumaVerificationModal = undefined;
        if (activeModal) {
          try {
            await activeModal.dismiss();
          } catch (dismissError) {
            console.warn('The completed Suma modal was already dismissed.', dismissError);
          }
        }

        if (!this.sumaRetryNoticeShown) {
          this.sumaRetryNoticeShown = true;
          void Swal2.fire({
            title: 'Necesitamos una nueva captura',
            text: 'La verificación anterior terminó sin aprobación. Inténtalo de nuevo con buena iluminación, sin reflejos y con todo el documento visible.',
            icon: 'warning',
            toast: true,
            position: 'top-start',
            timer: 9000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        }

        return false;
      }

      if (!verified) {
        return false;
      }

      await this.refreshVerificationProfile(undefined, false);
      if (this.destroyed || this.sumaCaptureOpening || this.sumaVerificationModal || captureGeneration !== this.sumaCaptureGeneration) return false;

      // The profile endpoint is authoritative. Keep the normalized response
      // as a defensive fallback if an edge cache returns the prior profile.
      if (this.isSumaReconciliationEligible() && responseKyc) {
        this.pr = { ...this.pr, kyc: responseKyc };
      }

      this.stopSumaStatusPolling();
      this.finishSumaReturnLoading();
      if (this.sumaVerificationModal) {
        await this.sumaVerificationModal.dismiss();
      }

      console.log('Suma verification reconciled with the persisted profile.');
      return true;
    } catch (error) {
      // A result can take a few seconds to become available after the provider
      // shows its success screen. Polling retries transient failures quietly.
      console.warn('Unable to synchronize the Suma verification status yet.', error);
      return false;
    } finally {
      this.sumaStatusSyncInFlight = false;
    }
  }

  private parseNestedSumaResponse(value: any): any {
    let parsed = value;

    for (let attempt = 0; attempt < 4 && typeof parsed === 'string'; attempt++) {
      const candidate = parsed.trim();
      if (!candidate) {
        break;
      }

      try {
        parsed = JSON.parse(candidate);
      } catch {
        break;
      }
    }

    return parsed;
  }

  private findSumaGlobalResult(value: any, depth = 0): string | null {
    const parsed = this.parseNestedSumaResponse(value);
    if (!parsed || typeof parsed !== 'object' || depth > 6) {
      return null;
    }

    const normalizedEntries = Object.entries(parsed).map(([key, entryValue]) => ({
      key: key.toLowerCase().replace(/[^a-z0-9]+/g, ''),
      value: entryValue,
    }));
    const direct = normalizedEntries.find(({ key, value: entryValue }) =>
      ['globalresult', 'overallresult', 'resultadoglobal', 'resultadogeneral'].includes(key)
      && ['string', 'number', 'boolean'].includes(typeof entryValue)
    );
    if (direct) {
      return String(direct.value).trim();
    }

    for (const child of Object.values(parsed)) {
      const result = this.findSumaGlobalResult(child, depth + 1);
      if (result) {
        return result;
      }
    }

    return null;
  }

  private isTrueFlag(value: any): boolean {
    return value === true || value === 1 || value === '1'
      || (typeof value === 'string' && value.toLowerCase() === 'true');
  }

  private isSumaReconciliationEligible(): boolean {
    const kyc = String(this.pr?.kyc || '').trim().toLowerCase();
    return kyc === 'sin validar'
      || kyc === 'en validacion'
      || kyc === 'en validación'
      || kyc === 'rechazado'
      || (kyc === 'pagado' && !this.isCheckoutStep());
  }

  private startSumaStatusPolling(): void {
    this.stopSumaStatusPolling();
    if (this.destroyed || this.sumaCaptureOpening || this.sumaVerificationModal) return;
    const generation = this.sumaPollingGeneration;
    this.sumaStatusPollingStartedAt = Date.now();

    const poll = async () => {
      if (this.destroyed || !this.isSumaReconciliationEligible()) {
        this.stopSumaStatusPolling();
        return;
      }

      const completed = await this.syncSumaVerificationStatus();
      if (generation !== this.sumaPollingGeneration || this.destroyed) {
        return;
      }
      const elapsed = Date.now() - (this.sumaStatusPollingStartedAt || Date.now());
      if (!completed && elapsed < this.sumaStatusPollingMaxMs) {
        this.sumaStatusPollingTimer = setTimeout(poll, this.sumaReturnLoading ? 2000 : this.sumaStatusPollingIntervalMs);
      } else {
        this.finishSumaReturnLoading();
      }
    };

    // Poll only after the provider has returned from capture. The capture
    // screen itself has no polling deadline and cannot be closed by old results.
    this.sumaStatusPollingTimer = setTimeout(poll, this.sumaReturnLoading ? 2000 : this.sumaStatusPollingIntervalMs);
  }

  private finishSumaReturnLoading(): void {
    if (this.sumaReturnTimer) {
      clearTimeout(this.sumaReturnTimer);
      this.sumaReturnTimer = undefined;
    }
    this.ngZone.run(() => { this.sumaReturnLoading = false; });
  }

  private stopSumaStatusPolling(): void {
    this.sumaPollingGeneration++;
    if (this.sumaStatusPollingTimer) {
      clearTimeout(this.sumaStatusPollingTimer);
      this.sumaStatusPollingTimer = undefined;
    }
    this.sumaStatusPollingStartedAt = undefined;
  }

  /**
   * The email-code endpoint persists the final KYC state on the server. Do
   * not advance this screen merely because the modal reports success: fetch
   * the profile and let its persisted `Verified` value drive the template.
   */
  private syncEmailVerificationStatus(): Promise<boolean> {
    if (this.destroyed) {
      return Promise.resolve(false);
    }

    if (this.pr?.kyc === 'Verified') {
      return Promise.resolve(true);
    }

    if (this.pr?.kyc !== 'MailVerification') {
      return Promise.resolve(false);
    }

    if (this.emailStatusSyncPromise) {
      return this.emailStatusSyncPromise;
    }

    const syncPromise = this.performEmailVerificationStatusSync();
    this.emailStatusSyncPromise = syncPromise;
    syncPromise.then(
      () => {
        if (this.emailStatusSyncPromise === syncPromise) {
          this.emailStatusSyncPromise = undefined;
        }
      },
      () => {
        if (this.emailStatusSyncPromise === syncPromise) {
          this.emailStatusSyncPromise = undefined;
        }
      }
    );

    return syncPromise;
  }

  private async performEmailVerificationStatusSync(): Promise<boolean> {
    try {
      await this.refreshVerificationProfile(undefined, false);
      const verified = ['Verified', 'Validado'].includes(this.pr?.kyc);

      if (!verified) {
        return false;
      }

      this.stopEmailStatusPolling();
      if (this.emailVerificationModal) {
        await this.emailVerificationModal.dismiss({ verified: true });
      }

      console.log('Email verification reconciled with the persisted profile.');
      return true;
    } catch (error) {
      console.warn('Unable to synchronize the email verification status yet.', error);
      return false;
    }
  }

  private startEmailStatusPolling(): void {
    this.stopEmailStatusPolling();
    this.emailStatusPollingStartedAt = Date.now();

    const poll = async () => {
      if (this.destroyed || this.pr?.kyc !== 'MailVerification') {
        this.stopEmailStatusPolling();
        return;
      }

      const completed = await this.syncEmailVerificationStatus();
      const elapsed = Date.now() - (this.emailStatusPollingStartedAt || Date.now());
      if (!completed && elapsed < this.emailStatusPollingMaxMs) {
        this.emailStatusPollingTimer = setTimeout(poll, this.emailStatusPollingIntervalMs);
      }
    };

    this.emailStatusPollingTimer = setTimeout(poll, this.emailStatusPollingIntervalMs);
  }

  private stopEmailStatusPolling(): void {
    if (this.emailStatusPollingTimer) {
      clearTimeout(this.emailStatusPollingTimer);
      this.emailStatusPollingTimer = undefined;
    }
    this.emailStatusPollingStartedAt = undefined;
  }

  private registerSumaResumeSync(): void {
    // On iOS a provider flow may temporarily background the WebView. Recheck
    // immediately when the app becomes active rather than making the user tap
    // the Suma step a second time.
    App.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) {
        return;
      }
      this.subscriptionRetryCount = 0;
      void this.reconcileCurrentSubscription();

      if (this.isSumaReconciliationEligible()) {
        void this.syncSumaVerificationStatus();
      } else if (this.pr?.kyc === 'MailVerification') {
        void this.syncEmailVerificationStatus();
      }
    }).then((listener) => {
      this.sumaAppStateListener = listener;
    }).catch(() => undefined);
  }

async ConfirmaciondeCorreo() {

	let data = {
	  email: this.profileinfo.user.email,
	};
  
	// Step 1: Request email confirmation
	try {
    Swal.fire({
      title: 'Procesando...',
      text: 'Email is being processed.',
      icon: 'success',
      timer: 3600, // Show the alert for 3 seconds
      timerProgressBar: true,
      toast: true,
      position: 'top-end',
      showConfirmButton: false
    });
	  const response = await this.request.createRequestPost('send-email', data);
     let responseData;
     if (typeof response === 'string') {
     responseData = JSON.parse(response);
     }
	  // Check if email confirmation was successful
	  
		const modal = await this.modalcontroller.create({
		  component: Confirmacion,
      cssClass: 'detailsInModal',
      canDismiss: true, // (forced globally for swipe close on all modals)
		  componentProps: {
			email: this.profileinfo.user.email,
      id:this.pr.id
		  },
		});
		this.emailVerificationModal = modal;
		modal.onDidDismiss().then(async (detail) => {
		  this.emailVerificationModal = undefined;
		  this.stopEmailStatusPolling();
      const statusId = Number(detail.data?.profile_status_id);
      if (detail.data?.verified && [3, 10].includes(statusId)) {
        // The endpoint committed this status. Display it immediately even if
        // the subsequent profile read fails or returns a cached older step.
        this.applyPersistedPurchaseStatus(statusId, statusId === 10 ? 'Verified' : 'Validado');
        try { await this.refreshVerificationProfile(undefined, false); } catch { /* Keep committed status. */ }
        this.applyPersistedPurchaseStatus(statusId, statusId === 10 ? 'Verified' : 'Validado');
        void this.reconcileCurrentSubscription();
      } else {
        await this.syncEmailVerificationStatus();
      }
		});
		await modal.present();
		this.startEmailStatusPolling();
  
		// Email confirmation sent successfully
		if (this.profileinfo && this.profileinfo.user) {
     // this.sendNotification('Estatus de tu perfil actualizado', '¡Felicitaciones! Continua con el siguiente paso para verificarte.');
		  console.log("Profile info and user exist. Displaying alert...");
		  Swal2.fire({
			title: 'Confirmacion de Correo Electronico',
			text: `Confirmacion de correo Enviada a ${this.profileinfo.user.email}`,
			icon: 'success',
			confirmButtonText: 'Understood',
			color: '#ffffff',
		  background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
		  }).then(() => {
			console.log("Alert displayed successfully.");
		  }).catch((error) => {
			console.error("Error displaying alert:", error);
		  });
		} else {
		  console.warn("Profile info or user does not exist. Alert not displayed.");
		}
	  
	} catch (error) {
    Swal2.fire({
		  title: 'Email confirmation not processed',
		  text: `Confirmation not sent to your email account ${this.profileinfo.user.email}`,
		  icon: 'error',
		  confirmButtonText: 'Understood',
		  color: '#ffffff',
		  background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
		}).then(() => {
		  console.log("Alert displayed successfully.");
		}).catch((error) => {
		  console.error("Error displaying alert:", error);
		});
	  console.error("Error:", error);
	  // Handle network errors or other unexpected errors here
	}
  }
  async Pay_verification(flow: VerificationPurchaseFlow): Promise<void> {
    if (this.purchaseInProgress) {
      return;
    }

    const isIOS = Capacitor.getPlatform() === 'ios';
    if (isIOS){
      const attemptId = this.beginPurchaseFeedback(flow);

      try {
        if (flow === 'initial-bundle') {
          await this.purchaseInitialAppleBundle(attemptId);
        } else if (flow === 'inscription') {
          await this.InscriptionToProduct(attemptId);
        } else {
          await this.subscribeToProduct(attemptId, 'finalize');
        }

        if (this.isCurrentPurchaseAttempt(attemptId)) {
          this.showQubitLoader = false;
          this.secureFeedback.succeed(
            flow === 'initial-bundle' || flow === 'inscription'
              ? 'Inscripción confirmada'
              : 'Suscripción activada'
          );
        }
      } catch (error) {
        if (this.isCurrentPurchaseAttempt(attemptId)) {
          this.showQubitLoader = false;
          if (error instanceof Error && error.message === 'SUBSCRIPTION_SYNC_PENDING') {
            this.secureFeedback.hide();
            this.scheduleSubscriptionSync(5000);
          } else if (this.isPurchaseCancelled(error)) {
            this.secureFeedback.hide();
          } else {
            this.secureFeedback.fail('No se pudo completar la compra');
          }
        }
        console.error('Apple purchase flow failed:', error);
      } finally {
        if (this.isCurrentPurchaseAttempt(attemptId)) {
          this.clearPurchaseFallbackTimer();
          this.purchaseInProgress = false;
          this.subscriptionReconciliation.purchaseInProgress = false;
          this.activePurchaseFlow = null;
          this.showQubitLoader = false;
        }
      }
    }else{
      Swal.fire({
        title: 'Procesando...',
        text: 'El producto se está procesando.',
        icon: 'success',
        timer: 6900, // Show the alert for 3.9 seconds
        timerProgressBar: true,
        toast: true,
        position: 'top-end',
        showConfirmButton: false
      });
      // Apple subscriptions are only available through StoreKit on iOS. Keep
      // the existing card-based path unchanged on web/Android.
      this.metodoTarjeta(flow === 'initial-bundle' ? 'inscription' : flow);
    }
  }

  private registerAppleProduct(productId: string, productType: string): void {
    if (this.store.get(productId)) {
      return;
    }

    this.store.register({
      id: productId,
      alias: productId,
      type: productType,
    });
  }

  private isActiveAppleEntitlement(product?: IAPProduct): boolean {
    if (!product || (!product.owned && product.state !== this.store.OWNED && product.state !== this.store.APPROVED)) {
      return false;
    }

    if (!product.expiryDate) {
      return true;
    }

    const expiryTime = new Date(product.expiryDate).getTime();
    return Number.isFinite(expiryTime) && expiryTime > Date.now();
  }

  private async reconcileCurrentSubscription(): Promise<void> {
    if (!this.pr?.id || this.purchaseInProgress || this.destroyed || this.subscriptionSyncRunning) return;
    this.subscriptionSyncRunning = true;
    try {
      const profile = await this.subscriptionReconciliation.sync();
      if (profile && String(profile.id) === String(this.pr.id) && !this.destroyed && !this.purchaseInProgress) {
        this.ngZone.run(() => {
          Object.assign(this.pr, profile);
          this.pr = { ...this.pr };
          this.typeTextCalled = false;
          this.textAlign = '';
        });
        if (Capacitor.getPlatform() === 'ios' && profile.subscription_payment_source === 'apple') {
          this.setSubscriptionPending(false);
        }
      }
    } catch (error) {
      console.warn('Subscription status is temporarily unavailable.', error);
    } finally {
      this.subscriptionSyncRunning = false;
      if (this.subscriptionActivationPending) this.scheduleSubscriptionSync(10000);
      else clearTimeout(this.subscriptionSyncTimer);
    }
  }

  private scheduleSubscriptionSync(delay: number): void {
    clearTimeout(this.subscriptionSyncTimer);
    if (!this.destroyed && this.subscriptionRetryCount < 3) {
      this.subscriptionRetryCount++;
      this.subscriptionSyncTimer = setTimeout(() => void this.reconcileCurrentSubscription(), delay);
    }
  }

  private setSubscriptionPending(pending: boolean): void {
    if (!pending) {
      clearTimeout(this.subscriptionSyncTimer);
      this.subscriptionRetryCount = 0;
    }
    this.ngZone.run(() => { this.subscriptionActivationPending = pending; });
    try {
      const key = `pending-apple-subscription:${this.pr.id}`;
      if (pending) localStorage.setItem(key, '1');
      else localStorage.removeItem(key);
    } catch { /* StoreKit retains the unfinished transaction for recovery. */ }
  }

  private appleSubscriptionMetadata(product: IAPProduct): Record<string, string> {
    const transaction: any = product.transaction || {};
    const metadata: Record<string, string> = { product_id: product.id };
    if (transaction.id || transaction.transactionId) metadata.transaction_id = String(transaction.id || transaction.transactionId);
    if (transaction.originalTransactionId || transaction.original_transaction_id) metadata.original_transaction_id = String(transaction.originalTransactionId || transaction.original_transaction_id);
    const expiry = product.expiryDate ? new Date(product.expiryDate) : null;
    if (expiry && Number.isFinite(expiry.getTime())) metadata.expires_at = expiry.toISOString();
    return metadata;
  }

  private refreshApplePurchases(productId: string, requireFresh = false): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let settled = false;
      const settle = (error?: Error) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        error ? reject(error) : resolve();
      };
      const timeout = setTimeout(() => {
        const product = this.store.get(productId);
        if (!requireFresh && (product?.loaded || product?.valid || this.isActiveAppleEntitlement(product))) {
          settle();
          return;
        }
        settle(new Error('IAP_ENTITLEMENT_REFRESH_TIMEOUT'));
      }, 15000);

      try {
        const refreshResult: any = this.store.refresh();
        refreshResult?.completed?.(() => settle());
        refreshResult?.failed?.(() => settle(new Error('IAP_ENTITLEMENT_REFRESH_FAILED')));
        refreshResult?.cancelled?.(() => settle(new Error('IAP_ENTITLEMENT_REFRESH_CANCELLED')));
      } catch (error) {
        settle(error instanceof Error ? error : new Error('IAP_ENTITLEMENT_REFRESH_FAILED'));
      }
    });
  }

  private executeAppleProductPurchase(
    productId: string,
    productType: string,
    eventFlow: 'inscription' | 'subscription',
    attemptId: number,
    refreshBeforeCheck: boolean,
    waitingMessage: string,
    approvedMessage: string,
    onApproved: (product: IAPProduct) => Promise<void>,
    onOwned: (product: IAPProduct) => Promise<void>,
  ): Promise<'purchased' | 'owned'> {
    return new Promise<'purchased' | 'owned'>((resolve, reject) => {
      this.store.verbosity = this.store.DEBUG;
      this.registerAppleProduct(productId, productType);

      let settled = false;
      let processing = false;

      const cleanup = () => {
        this.store.off(approvedHandler);
        this.store.off(cancelledHandler);
        this.store.off(errorHandler);
      };
      const resolveOnce = (outcome: 'purchased' | 'owned') => {
        if (settled) return;
        settled = true;
        cleanup();
        resolve(outcome);
      };
      const rejectOnce = (error: unknown) => {
        if (settled) return;
        settled = true;
        cleanup();
        reject(error);
      };
      const approvedHandler = (approvedProduct: IAPProduct) => {
        if (settled || processing || !this.claimIapApproval(eventFlow, attemptId)) return;
        processing = true;
        this.clearPurchaseFallbackTimer();
        this.updatePurchaseStatus('Compra autorizada', approvedMessage, attemptId);

        if (!this.claimIapSuccess(eventFlow, attemptId)) {
          processing = false;
          return;
        }

        void onApproved(approvedProduct)
          .then(() => {
            approvedProduct.finish();
            resolveOnce('purchased');
          })
          .catch(rejectOnce);
      };
      const cancelledHandler = () => {
        console.info(`Apple purchase ${productId} was cancelled.`);
        this.clearPurchaseFallbackTimer();
        rejectOnce(new Error('IAP_PURCHASE_CANCELLED'));
      };
      const errorHandler = (error: unknown) => {
        console.error(`Apple purchase ${productId} failed.`, error);
        this.clearPurchaseFallbackTimer();
        rejectOnce(error);
      };

      this.store.once(productId).approved(approvedHandler);
      this.store.once(productId).cancelled(cancelledHandler);
      this.store.once(productId).error(errorHandler);

      const start = async () => {
        if (refreshBeforeCheck) {
          await this.refreshApplePurchases(productId);
        }

        if (settled || processing) return;
        const product = this.store.get(productId);
        if (!product) {
          throw new Error(`IAP_PRODUCT_NOT_FOUND:${productId}`);
        }

        if (this.isActiveAppleEntitlement(product)) {
          processing = true;
          await onOwned(product);
          resolveOnce('owned');
          return;
        }

        // A prior purchase can be restored in APPROVED state when its backend
        // delivery failed. Deliver it instead of creating another order.
        if (product.state === this.store.APPROVED) {
          approvedHandler(product);
          return;
        }

        if (product.state === this.store.INVALID || (product.loaded && !product.valid)) {
          throw new Error(`IAP_PRODUCT_INVALID:${productId}`);
        }

        this.updatePurchaseStatus('Esperando confirmación', waitingMessage, attemptId);
        const order = this.store.order(productId);
        order.then(() => this.clearPurchaseFallbackTimer());
        order.error((error: unknown) => rejectOnce(error));
      };

      void start().catch(rejectOnce);
    });
  }

  private async purchaseInitialAppleBundle(attemptId: number): Promise<void> {
    // Restore both products before ordering. This makes retries safe when one
    // purchase succeeded in a previous attempt and the other did not.
    this.registerAppleProduct(this.productId, this.store.NON_CONSUMABLE);
    this.registerAppleProduct(this.productId2, this.store.PAID_SUBSCRIPTION);
    this.updatePurchaseStatus('Comprobando compras', 'Restaurando tus compras activas de App Store.', attemptId);
    await this.refreshApplePurchases(this.productId2);

    // KYC-first route: inscription is charged first and an active Premium
    // entitlement is then required before the email step can open.
    try {
      await this.InscriptionToProduct(attemptId, false);
    } catch (error) {
      throw error;
    }

    try {
      await this.subscribeToProduct(attemptId, 'finalize', false);
    } catch (error) {
      if (error instanceof Error && error.message === 'SUBSCRIPTION_SYNC_PENDING') throw error;
      void Swal2.fire({
        title: 'Inscripción completada',
        text: 'Premium quedó pendiente. Vuelve a intentarlo para continuar con la verificación de correo.',
        icon: 'warning',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
        showConfirmButton: false,
        timer: 5500,
      });
      throw error;
    }
  }

  async InscriptionToProduct(
    attemptId = this.purchaseAttemptId,
    refreshBeforeCheck = true,
  ): Promise<void> {
    this.updatePurchaseStatus('Consultando App Store', 'Validando la compra de inscripción.', attemptId);

    await this.executeAppleProductPurchase(
      this.productId,
      this.store.NON_CONSUMABLE,
      'inscription',
      attemptId,
      refreshBeforeCheck,
      'Completa la compra de inscripción en el diálogo seguro de Apple.',
      'Apple confirmó el pago. Verificando la transacción.',
      async (product) => this.deliverInscription(product, attemptId),
      async (product) => this.deliverInscription(product, attemptId),
    );
  }

  private async deliverInscription(product: IAPProduct, attemptId: number): Promise<void> {
    this.updatePurchaseStatus('Activando verificación', 'Sincronizando tu inscripción con Laniakea.', attemptId);
    const rawResponse = await this.request.createRequestPost('IN-APP-PURCHASE-1', {
      profile_id: this.pr.id,
      payment_source: 'apple',
    });
    const response = typeof rawResponse === 'string'
      ? JSON.parse(rawResponse)
      : rawResponse;

    // A successful HTTP response is not enough: the idempotent endpoint can
    // deliberately leave an out-of-sequence profile unchanged. Do not finish
    // StoreKit or announce success unless inscription was applied previously
    // or by this request.
    const persistedStatusId = Number(response?.profile_status_id);
    const inscriptionWasPersisted = response?.transition_applied === true
      || response?.already_processed === true
      || [3, 5, 9, 10].includes(persistedStatusId);

    if (response?.deferred === true || !inscriptionWasPersisted) {
      throw new Error('INSCRIPTION_ACTIVATION_DEFERRED');
    }

    const inscriptionCompletedStatuses = new Set([
      'Pagado',
      'MailVerification',
      'Verified',
      'Validado',
    ]);

    try {
      await this.refreshVerificationProfile(attemptId);
    } catch (error) {
      console.warn(
        'Inscription was persisted, but the profile refresh failed; using the committed endpoint status.',
        error,
      );
      this.applyPersistedPurchaseStatus(response?.profile_status_id, 'Pagado');
    }

    // A successful profile request can still be served from a stale cache.
    // Never strand an already-paid StoreKit transaction on that stale read.
    if (!inscriptionCompletedStatuses.has(this.pr?.kyc)) {
      this.applyPersistedPurchaseStatus(response?.profile_status_id, 'Pagado');
    }

    if (!inscriptionCompletedStatuses.has(this.pr?.kyc)) {
      throw new Error(`INSCRIPTION_STATUS_NOT_RECONCILED:${this.pr?.kyc || 'unknown'}`);
    }

    console.log('Inscription status fetched and UI updated.', this.pr?.kyc);
    void this.sendNotification(
      'Estatus de tu perfil actualizado',
      '¡Felicitaciones! Continúa con el siguiente paso para verificarte.',
      this.iapNotificationKey('inscription', attemptId, product),
    ).catch((error) => {
      // A notification is secondary and must never roll back or strand a paid
      // transaction before StoreKit is finished.
      console.warn('Inscription notification could not be sent.', error);
    });
  }

  async subscribeToProduct(
    attemptId = this.purchaseAttemptId,
    mode: SubscriptionActivationMode = 'finalize',
    refreshBeforeCheck = true,
  ): Promise<void> {
    this.updatePurchaseStatus(
      mode === 'initial' ? 'Activando suscripción' : 'Comprobando suscripción',
      'Validando tu entitlement Premium con App Store.',
      attemptId,
    );

    await this.executeAppleProductPurchase(
      this.productId2,
      this.store.PAID_SUBSCRIPTION,
      'subscription',
      attemptId,
      refreshBeforeCheck,
      'Completa la suscripción en el diálogo seguro de Apple.',
      'Apple confirmó la suscripción.',
      async (product) => this.deliverSubscription(product, attemptId, mode),
      async (product) => this.deliverSubscription(product, attemptId, mode),
    );
  }

  private async deliverSubscription(
    product: IAPProduct,
    attemptId: number,
    mode: SubscriptionActivationMode,
  ): Promise<void> {
    if (mode === 'initial') {
      // Record the channel now, but explicitly keep this request status-only.
      // The inscription endpoint remains the only initial-bundle transition
      // that can reveal the KYC step.
      try {
        await this.request.createRequestPost('IN-APP-PURCHASE-2', {
          profile_id: this.pr.id,
          payment_source: 'apple',
          source_only: true,
        });
      } catch (error) {
        // The final subscription reconciliation retries this persistence if a
        // transient network failure occurs after StoreKit approved the payment.
        console.warn('Apple subscription source could not be recorded yet.', error);
      }
      console.log('Initial Apple subscription source recorded; onboarding status remains unchanged.');
      return;
    }

    this.updatePurchaseStatus('Activando Premium', 'Sincronizando tu suscripción con Laniakea.', attemptId);
    this.setSubscriptionPending(true);
    const payload = {
      profile_id: this.pr.id,
      payment_source: 'apple',
      ...(mode === 'finalize' ? { subscription_state: 'active' } : {}),
      ...this.appleSubscriptionMetadata(product),
    };
    let response: any;
    for (let retry = 0; retry < 3; retry++) {
      try {
        const rawResponse = await this.request.createRequestPost('IN-APP-PURCHASE-2', payload);
        response = typeof rawResponse === 'string' ? JSON.parse(rawResponse) : rawResponse;
        if (Number(response?.code) !== 200) throw new Error('SUBSCRIPTION_NOT_PERSISTED');
        break;
      } catch (error) {
        if (retry === 2 || this.destroyed) throw new Error('SUBSCRIPTION_SYNC_PENDING');
        await new Promise(resolve => setTimeout(resolve, 1000 * (retry + 1)));
      }
    }

    const persistedStatusId = Number(response?.profile_status_id);
    if (response?.subscription_state === 'inactive') {
      this.setSubscriptionPending(false);
      throw new Error('SUBSCRIPTION_INACTIVE');
    }
    const subscriptionWasPersisted = response?.transition_applied === true
      || response?.already_processed === true
      || [3, 9, 10].includes(persistedStatusId);

    if (!subscriptionWasPersisted || response?.ignored_source_mismatch) {
      throw new Error('SUBSCRIPTION_SYNC_PENDING');
    }
    this.setSubscriptionPending(false);

    try {
      await this.refreshVerificationProfile(attemptId);
    } catch (error) {
      console.warn(
        'Subscription was persisted, but the profile refresh failed; using the committed endpoint status.',
        error,
      );
      this.applyPersistedPurchaseStatus(response?.profile_status_id, 'MailVerification');
    }

    if (this.pr?.kyc !== this.persistedVerificationStatusName(response?.profile_status_id, 'MailVerification')) {
      this.applyPersistedPurchaseStatus(response?.profile_status_id, 'MailVerification');
    }

    if (!['Validado', 'MailVerification', 'Verified'].includes(this.pr?.kyc)) {
      throw new Error(`SUBSCRIPTION_STATUS_NOT_RECONCILED:${this.pr?.kyc || 'unknown'}`);
    }

    console.log('Subscription status fetched and UI updated.', this.pr?.kyc);
    void Swal2.fire({
      title: 'Suscripción activa',
      text: 'Tu suscripción de Laniakea está activa.',
      icon: 'success',
      color: '#ffffff',
      background: '#010f4e',
      position: 'top-end',
      timerProgressBar: true,
      toast: true,
      showConfirmButton: false,
      timer: 4200,
    });
    void this.sendNotification(
      'Suscripción activada',
      'Tu suscripción de Laniakea se activó correctamente.',
      this.iapNotificationKey('subscription', attemptId, product),
    ).catch((error) => {
      console.warn('Subscription notification could not be sent.', error);
    });
  }
  
  sendNotification(title, body, notificationEventKey?: string) {
   
    return new Promise((resolve, reject) => {
      const notification = {
        title: title,
        body: body,
        profile_id:this.pr.id,
        notification_type: notificationEventKey ? 'iap_purchase_success' : undefined,
        notification_event_key: notificationEventKey,

      };
  
      this.request.createRequestPost('GreatAtractorNotifications', notification)
        .then((data) => {
          Swal2.fire({
            title: 'Connection created',
            text: 'Nuevo status asequida exitosamente',
            icon: 'success',
            confirmButtonText: 'Understood',
            color: '#ffffff',
            background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
          });
          resolve(data);
        }).catch((error) => {
          console.error('Failed to send notification:', error);
          reject(error);
        });
    });
  }
  typeText(text: string, delay: number) {
    	 // Check if typeText has already been called for this currentStateIndex
	 if (this.typeTextCalled) {
		return;
	  }
    this.typeTextCalled = true; // Set the flag to indicate 
    let index = 0;
    this.textAlign='';
    const interval = setInterval(() => {
      if (index < text.length) {
        this.textAlign += text.charAt(index);
        index++;
      } else {
        clearInterval(interval);
      }
    }, delay);
  }
}
